import { DateTime } from 'luxon';

import { DateRangeType } from 'application-types';

export function hasSlotEnded(
  { endDate }: DateRangeType,
  now: DateTime
): boolean {
  return endDate != null && endDate.getTime() <= now.toMillis();
}
